var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",class:_vm.$route.meta.background === 'white' && 'u__background--white'},[_c('div',{staticClass:"page-header"},[_c('Content',[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title))])])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }